import { useCallback, useState } from "react";

import { ApiCallStatus, ApiEndpoints, ApiUserData, getApiClient } from "../../../api-http";
import { useDataLayer } from "../../../hooks/use-data-layer";
import { GoogleAnalyticsEvent } from "../../../utils/analytics";

export const usePatchUserInfo = (): [
  (userId: string, data: Partial<ApiUserData>) => void,
  ApiCallStatus,
] => {
  const [status, setStatus] = useState<ApiCallStatus>(ApiCallStatus.LOADING);
  const { pushEvent } = useDataLayer();
  const patchUser = useCallback(
    (userId: string, data: Partial<ApiUserData>) => {
      getApiClient()
        .patch(`${ApiEndpoints.USERS}/${userId}`, data, {
          headers: {
            "Accept-Language": "en-GB",
          },
        })
        .then(() => {
          setStatus(ApiCallStatus.SUCCESS);
          pushEvent({
            event: GoogleAnalyticsEvent.UpdatePersonalAreaProfile,
          });
        })
        .catch((err) => {
          console.error(err);
          setStatus(ApiCallStatus.FAILED);
        });
    },
    [pushEvent]
  );

  return [patchUser, status];
};
